// Identify developer/test accounts (Humza's) so they can be hidden from agent
// pickers and "Viewing: All Agents" lists. This HIDES them from the UI only —
// it does not delete any account or any of their (often real) deal records.
// Mirrors the long-standing exclusion in status-sheet.jsx.

export const TEST_ACCOUNT_IDS = [
  "07GXeA7MIZS2chN5oijih2qOJiI3", // humza agent 2
  "DRwIpzUuHMP8b1f3LyQVCkDyh832", // humza samiullah
  "1d4zL9htjpUjH2ILU4b3vG0PbF13", // humza client
  "3VaFRZUwifPXVm3dSf2P2NbZPRC2", // Huzma Clientcare
];

const TEST_ID_SET = new Set(TEST_ACCOUNT_IDS);

export function isTestAgent(u) {
  if (!u) return false;
  if (u.id && TEST_ID_SET.has(u.id)) return true;
  const blob =
    `${u.firstname || ""} ${u.lastname || ""} ${u.name || ""} ${u.email || ""}`.toLowerCase();
  return blob.includes("humza") || blob.includes("huzma");
}

// Return the list with developer/test accounts removed (for agent dropdowns).
export function excludeTestAgents(list) {
  return (list || []).filter((u) => !isTestAgent(u));
}
